import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Pagination } from '~/components/Pagination/Pagination';
import { LicensesListTable } from './components/licenses-table';
import { useAuthentication } from '~/hooks/useAuthentication';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { Button } from '~/components/Button/Button';
import { useLicensesListQuery } from '../queries';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';
import { usePersonQuery } from '~/pages/person/queries';

export const Page = withPrivateRoute(() => {
  const navigate = useNavigate();

  const { id } = useParams(idParamSchema.parse);
  const { can } = useAuthentication();

  const { data: person } = usePersonQuery(id);
  const { data, isLoading } = useLicensesListQuery({ person: id });

  if (!person) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Licenser" subText={`${person.first_name} ${person.last_name}`} />

        {can('create-lifter-license', person.club.id) && (
          <Button type="button" onClick={() => navigate('create')}>
            Ansök om licens
          </Button>
        )}
      </PageLayout.Header>

      <PageLayout.Section>
        <LicensesListTable licenses={data?.results ?? []} isLoading={isLoading} />
        <Pagination count={data?.count} />
      </PageLayout.Section>
    </Fragment>
  );
});
